import style from "./styles/RigthList.module.css";

import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { updateList } from "../../redux/actions";
import { useDispatch } from "react-redux";

import { IState, IItemVideo } from "../../interface/interface";

// Order imports
// Styles
// Native and other dependences
// Actions Redux
// Actions Controllers and constants
// Components
// Interfaces

const RigthList = () => {
  //const [videoList, setVideoList] = useState<IObjectVideo[]>([{ index: 0, data: { videoId: "", title: "", image: "", channel: "" } }])
  const [videoList, setVideoList] = useState<IItemVideo[]>([
    { position: 0, videoId: "", title: "", image: "", channel: "" },
  ]);
  // const [newVideo, setNewVideo] = useState<IObjectVideo>({ index: 0, data: { videoId: "", title: "", image: "", channel: "" } });
  const [transport, setTransport] = useState<IItemVideo>({
    position: 0,
    videoId: "",
    title: "",
    image: "",
    channel: "",
  });

  const listVideo = useSelector<IState, IState["listVideos"]>(
    (state) => state.listVideos
  );
  const dispatch = useDispatch();

  useEffect(() => {
    setVideoList(listVideo.videos);
  }, [listVideo]);

  const onDrag = (video: IItemVideo) => {
    // console.log("sale el drag");
    // value se toma del elemento al cual se arrastra
    // console.log(index, data, 'lo que sale'); // ejemplo --> "1"
    setTransport(video);
  };

  const onDrop = (value: number) => {
    // console.log(transport, 'se transporta'); // "1", data
    // console.log(value, 'recibido'); // "2"

    let oldIndex: number = transport.position;

    let newIndex: number = Number(value);
    // let data: IData = transport.data; // Guarda la copia data que se mueve

    let newStateData: IItemVideo[] = videoList.map((d: IItemVideo) => {
      return {
        ...d,
        videoId: d.videoId,
        title: d.title,
        image: d.image,
        channel: d.channel,
      };
    });

    newStateData.splice(newIndex, 0, {
      position: newIndex, // si no es este es newIndex
      videoId: transport.videoId,
      title: transport.title,
      image: transport.image,
      channel: transport.channel,
    });

    if (newIndex > oldIndex) {
      newStateData.splice(oldIndex, 1);
    } else {
      newStateData.splice(oldIndex + 1, 1);
    }
    // console.log(newStateData, 'el nuevo estado uno')

    let newState: IItemVideo[] = [];

    for (var i = 0; i < newStateData.length; i++) {
      let element = {
        position: videoList[i].position,
        videoId: newStateData[i].videoId,
        title: newStateData[i].title,
        image: newStateData[i].image,
        channel: newStateData[i].channel,
      };
      newState.push(element);
    }
    setVideoList(newState);
    // console.log(newState, 'el nuevo estado dos')
    dispatch(updateList(newState));
  };

  // const onChangeNewVideo = (value: string) => {
  //     setNewVideo({ index: videoList.length, data: {videoId: "", title: value, image: ""} })
  // }

  const removeItem = (value: number) => {
    let newState = [...videoList];
    newState.splice(value, 1);
    // Voy a recorrer para reasignar valores a los ìndices
    // para que siga funcionando todo

    for (let i = value; i < newState.length; i++) {
      newState[i].position = i;
    }
    setVideoList(newState);
    // console.log(newState, value, ' el nuúmero que me llega');
    dispatch(updateList(newState));
  };

  const upItem = (video: IItemVideo) => {
    if (video.position > 0) {
      // console.log(video, 'llega up');
      // video = {index: 0, data: {data del video}};
      let newState = [...videoList];
      let prevObj = { ...video };
      let nextObj = { ...videoList[video.position - 1] };

      newState[video.position] = {
        ...newState[video.position],
        videoId: nextObj.videoId,
        title: nextObj.title,
        image: nextObj.image,
        channel: nextObj.channel,
      };

      newState[video.position - 1] = {
        ...newState[video.position - 1],
        videoId: prevObj.videoId,
        title: prevObj.title,
        image: prevObj.image,
        channel: prevObj.channel,
      };
      // console.log(prevObj, nextObj,newState);
      setVideoList(newState);
      dispatch(updateList(newState));
    }
  };

  const downItem = (video: IItemVideo) => {
    if (video.position < videoList.length - 1) {
      // console.log(video, 'llega up');
      // video = {index: 0, data: {data del video}};
      let newState = [...videoList];
      let nextObj = { ...video };
      let prevObj = { ...videoList[video.position + 1] };

      newState[video.position] = {
        ...newState[video.position],
        videoId: prevObj.videoId,
        title: prevObj.title,
        image: prevObj.image,
        channel: prevObj.channel,
      };

      newState[video.position + 1] = {
        ...newState[video.position + 1],
        videoId: nextObj.videoId,
        title: nextObj.title,
        image: nextObj.image,
        channel: nextObj.channel,
      };

      setVideoList(newState);
      dispatch(updateList(newState));
    }
  };

  return (
    <>
      <div className={style.mainRigthList}>
        {/* <form>
                <input type="text" value={newVideo.data.title}
                onChange={(e) => onChangeNewVideo(e.target.value)} />
                
                <button onClick={(e) => addVideo(e)}>Agregar Video</button>
            </form> */}
        {/* <h2>Playlist</h2> */}
        <div className={style.rigthListBox}>
          <ul>
            {videoList.length &&
              videoList.map((video: IItemVideo) => {
                return (
                  <div
                    className={style.rigthMiniCardImage}
                    style={{
                      backgroundImage: `url(${video.image})`,
                    }}
                    key={video.position}
                  >
                    <div className={style.rigthMiniCard} key={video.position}>
                      <li
                        className={style.listMiniCard}
                        draggable="true"
                        key={video.position}
                        value={video.title}
                        onDragOver={(e) => e.preventDefault()}
                        onDragStart={() => onDrag(video)}
                        onDrop={() => onDrop(video.position)}
                      >
                        <div className={style.miniCardTop}>
                          <p className={style.card__channel}>{video.channel}</p>
                        </div>
                        <div className={style.miniCardInfo}>
                          <p className={style.card__title}>{video.title}</p>
                        </div>
                        <div className={style.miniCardButtons}>
                          <button onClick={() => upItem(video)}>↑</button>
                          <button onClick={() => downItem(video)}>↓</button>
                          <button onClick={() => removeItem(video.position)}>
                            x
                          </button>
                        </div>
                      </li>
                    </div>
                  </div>
                );
              })}
          </ul>
        </div>

        {/* {videoList ? JSON.stringify(videoList) : null}
            <p></p>
            {newVideo ? JSON.stringify(newVideo) : null} */}
      </div>
    </>
  );
};

export default RigthList;
